import { call, select, takeEvery, throttle, fork, put } from 'redux-saga/effects';
import { delay } from 'redux-saga';
// import * as Sentry from '@sentry/browser'

import { getProfile } from 'redux/selectors/user';
import { SET_TOKEN, TRACK_EVENT, UPDATE_ANALYTICS_PROFILE } from 'redux/reducers/user';
import { RENAME_ID, SET_OPTION } from 'redux/reducers/orders';

import request from 'helpers/api';
import { checked } from '../reducers/giftcards';
import { setSidebar } from '../reducers/app';
import { getActiveBookId, getActiveOrderId, getActiveSpreadId, getActiveSpreadName } from '../selectors/app';
import { getCurrentDesign } from '../selectors/design';

const UPDATE_THROTTLE = 30000;

// function * doUpdateAnalyticsProfile () {
//   yield delay(1000) //
//
//   try {
//     const token = yield select(state => state.getIn(['user', 'token'], null))
//
//     if (token) {
//       const profile = yield select(state => getProfile(state))
//       const analyticsData = yield call(request, 'user/analytics-profile', {
//         auth: true
//       })
//
//       // Sentry.configureScope(scope => {
//       //   scope.setUser({
//       //     id: profile.get('id'),
//       //     username: profile.get('first_name'),
//       //     email: profile.get('email')
//       //   })
//       // })
//     }
//   } catch (e) {
//     pe(e)
//   }
// }

function* doTrack({ event, data = {} }) {
  try {
    const orderId = yield select(getActiveOrderId);
    const activeBookId = yield select(getActiveBookId);
    const activeSpreadId = yield select(getActiveSpreadId);
    const activeSpreadName = yield select(getActiveSpreadName);

    const order = yield select(state => state.getIn(['orders', orderId]));

    const bookIdentifier = yield select(state =>
      state
        .get('books')
        .find(book => book.get('id') === activeBookId)
        .get('identifier')
    );
    const design = yield select(state =>
      state.get('designs').find(design => design.get('id') === getCurrentDesign(state))
    );
    const childId = order.getIn(['child', 'id']);

    yield call(request, 'user/track', {
      method: 'post',
      auth: true,
      body: {
        event,
        data: JSON.stringify({
          order_id: orderId,
          child_id: childId,
          product_id: bookIdentifier,
          design_id: design.get('identifier'),
          spread_id: activeSpreadId,
          spread_name: activeSpreadName,
          ...data,
        }),
      },
    });
  } catch (e) {
    pe(e);
  }
}

function* logErrors() {
  window.onerror = (msg, url, line, column, error) => {
    pe(error);
    return false;
  };
}

export default function* saga() {
  yield fork(logErrors);
  yield takeEvery(TRACK_EVENT, doTrack);

  // yield takeEvery(UPDATE_ANALYTICS_PROFILE, doUpdateAnalyticsProfile);

  // const updateOnActions = [
  //   UPDATE_ANALYTICS_PROFILE,
  //   SET_TOKEN,
  //   RENAME_ID,
  //   SET_OPTION
  // ]
  // yield throttle(UPDATE_THROTTLE, updateOnActions, doUpdateAnalyticsProfile)
}



// WEBPACK FOOTER //
// ./app/redux/sagas/analytics.js